import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, displayNo }) {
  return (
    <div className="notice-template-row">
      <div className="notice-template-col-no">{displayNo}</div>

      <div className="notice-template-col-title">
        <Link
          to={`/stdcouncil-log/Notice/${item.id}`}
          className="notice-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="notice-template-col-writer">{item.writer}</div>
      <div className="notice-template-col-date">{item.date}</div>
      <div className="notice-template-col-view">{item.view}</div>
    </div>
  );
}